module.exports = __webpack_public_path__ + "img/orange_116.6edece24.png";